/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Synchronized cohort/exam lifecycle phase (orthogonal to run `state`).
 */
export type OralExamSessionPhase = (typeof OralExamSessionPhase)[keyof typeof OralExamSessionPhase];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamSessionPhase = {
  pre_flight: 'pre_flight',
  group_briefing: 'group_briefing',
  in_exam: 'in_exam',
  post_exam: 'post_exam',
} as const;
